import React from 'react';

import { Control } from 'react-hook-form';
import { LbInput, LbSelect, LbDatePicker } from '@infoods/lifebase-ui';

import {
  InputBox,
  PhoneNumberInput,
} from '../../../../shared/components/form-components';
import { validateEmail, validateAge } from '../../../../shared/utils/reactHookFormUtils';
import { genderOptions } from '../../../../shared/constants/user-info/gender';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { CombinedCustomerInfo } from '../../../interfaces/Customer';
import { CustomerGroupSelector } from './CustomerGroupSelectore/CustomerGroupSelectore';

type PersonalDataFormProps = {
  control: Control<CombinedCustomerInfo>;
};

const PersonalDataForm = ({ control }: PersonalDataFormProps) => {
  const generalInputProps = {
    control,
    size: 'small',
    variant: 'standard',
  } as const;

  const privateInfoProps = { InputProps: { className: 'private-info' } };

  const { isSuperAdmin } = loggedInUserDataStore;

  return (
    <InputBox title="Personal Data">
      <LbInput
        {...generalInputProps}
        {...privateInfoProps}
        name="user.firstName"
        label="First Name"
        rules={{ required: 'First Name is required' }}
      />
      <LbInput
        {...generalInputProps}
        {...privateInfoProps}
        name="user.lastName"
        label="Last Name"
        rules={{ required: 'Last Name is required' }}
      />
      <LbInput
        {...generalInputProps}
        {...privateInfoProps}
        name="user.email"
        label="Email address"
        type="email"
        rules={{ required: 'Email is required', validate: { validateEmail } }}
        {...privateInfoProps}
      />
      <PhoneNumberInput
        {...generalInputProps}
        {...privateInfoProps}
        name="customer.cellPhone"
        label="Cell Phone"
        rules={{ required: 'Cell Phone is required' }}
      />
      <LbDatePicker
        {...generalInputProps}
        {...privateInfoProps}
        name="customer.dob"
        label="Date of Birth"
        helperText="You need to be at least 14 years to join the LifeBase"
        openTo="year"
        rules={{
          required: 'Date of Birth is required',
          validate: { validateMinAge: (value) => validateAge(value, 14) },
        }}
        {...privateInfoProps}
      />
      <LbSelect
        {...generalInputProps}
        {...privateInfoProps}
        name="customer.gender"
        label="Gender"
        options={genderOptions}
        rules={{ required: 'Gender is required' }}
      />
      {/* We should disable ability to change user group by super admin as it was before on angular flow */}
      {!isSuperAdmin && <CustomerGroupSelector control={control} />}
    </InputBox>
  );
};

export { PersonalDataForm };
